const colombia = (vm, row, data) => {

    const columna = 10;
    const host = vm.GLOBAL.SERVER_HOST;
    const empresa = vm.empresa;
    const td = $("td", row).eq(columna);

 var url = data.parametros.electronica.url;

    if (data.estado == "G") {
        if (data.url_factura != null) {
            const viewPDF1 = $("<a class='btn btn-sm bg-dian' target='_blank' href='" + data.url_factura + "'><i class='fa-solid fa-file-pdf'></i> DIAN</a>");
            td.append(viewPDF1);

            try {
                if (data.parametros.electronica.proveedor == "DIGITALSAS") {
                   
                    const viewPDF2 = $("<a class='btn btn-sm bg-kubber' target='_blank' href='" + url + "/pdf/" + data.public_hasp + "'><i class='fa-solid fa-file-pdf'></i> KUBBER</a>");
                    td.append(viewPDF2);
                }
            } catch (error) { }


        }
    }

    // PRE FACTURA Y EMITIR
    if (data.public_hasp == null && data.documento_id == vm.GLOBAL.DOCUMENTO.FACTURA_ELECTRONICA) {

        const viewPRE = $("<a class='btn btn-sm btn-white' target='_blank' href='" + url + "/preFactura/" + data.tercero_hasp + "'><i class='fa-solid fa-file-pdf'></i> PRE FACTURA</a>");
        td.append(viewPRE);

        const enviarPRE = $("<button class='btn btn-sm btn-info' data-uniqueid='" + data.uniqueid + "'><i class='fa-solid fa-check'></i>EMITIR</button>");
        $(enviarPRE).on("click", function () { vm.reintentarFactura(data, this); });
        td.append(enviarPRE);
    }

    // INACTIVAR
    if (data.public_hasp == null) {
        const inactivarBtn = $("<button title='BORRAR FACTURA NO EMITIDA' class='btn btn-sm btn-danger'><i class='fa-solid fa-xmark'></i></button>");
        $(inactivarBtn).on("click", function () { vm.inactivarFactura(data, this); });
        td.append(inactivarBtn);
    }


};

export default colombia;